<template>
  <div class="case-progress">
    <div class="case-progress-left">
      <Timeline class="time-line-body">
        <TimelineItem v-for="(item, index) in processList" :key="index">
          <!-- 结算节点如果有认领/录入，则标识特殊样式 -->
          <Icon
            v-if="item.code === 'ST' && item.state === 3" slot="dot"
            type="md-radio-button-off" :size="18"
            :color="styles.globalMainColor"
          />
          <Icon
            v-else-if="item.colorMark" slot="dot"
            type="ios-radio-button-on" :size="18"
            :color="styles.globalMainColor"
          />
          <Icon
            v-else slot="dot"
            type="md-radio-button-off" :size="18"
            :color="styles.borderColor"
          />
          <Row class="line-content">
            <Row class="line-right">
              <span
                :class="['line-name', !item.colorMark ? 'not-arrived' : '']"
                @click="item.state == 0 ? '' : chooseNode(item.code, item.processId, item.state, item.editable, item)"
              >{{
                item.name
              }}</span>
              <!--  -->
              <!-- <Button v-for="optional in item.optionalNode" v-if="(!optional.flag) && lockKey === index && item.optionalNode" :key="optional.id"
                class="list-options" :disabled="item.state !== 1" size="small" type="warning"
                @click="item.state == 0 ? '' : chooseOptionalNode(optional.code, item.processId, optional.id,optional)">{{
                    optional.name
                }}</Button> -->
              <template v-if="index === buttonIndex">
                <Button
                  v-for="(m,n) in codeButton" :key="n"
                  class="list-options" size="small"
                  type="warning" @click="clickCodeButton(m.value)"
                >{{ m.name }}</Button>
              </template>
            </Row>

            <Row
              v-for="log in item.logList" :key="log.id"
              class="line-detail"
            >
              <span class="line-date">{{ common.formatTime(log.operateTime, 4) }}</span>
              <span :class="['line-text', log.style]">{{ log.content }}</span>
            </Row>

          </Row>
        </TimelineItem>
      </Timeline>
    </div>
    <div class="case-progress-right">
      <!-- 发函 -->
      <send-letter
        v-if="tabActive == 'LL'"
        :key="processId"
        :process-id="processId"
        :case-id="caseId"
        :node-id="nodeId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 诉讼方案 -->
      <lawsuit-programme
        v-if="tabActive == 'PN_BB'"
        v-bind="$attrs"
        :key="processId"
        :case-state="caseState"
        :process-id="processId"
        :case-id="caseId"
        :project-id="projectId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 起诉 -->
      <prosecute
        v-if="tabActive == 'RR'"
        :key="processId"
        :case-state="caseState"
        :process-id="processId"
        :case-id="caseId"
        :process-state="processState"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 庭前准备 -->
      <pretrial
        v-if="tabActive == 'PL'"
        :key="processId"
        :case-state="caseState"
        :prev-code="prevCode"
        :process-id="processId"
        :case-id="caseId"
        :project-id="projectId"
        :edit-state="editable"
        :process-list="processList"
        :case-trial-state="caseTrialState"
        @reloadProcess="reloadProcess"
      />
      <!-- 庭审 -->
      <case-trial
        v-if="tabActive == 'CG_CG'"
        :key="processId"
        :case-state="caseState"
        :process-id="processId"
        :case-id="caseId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 判决 -->
      <adjudicate
        v-if="tabActive == 'JT_BB'"
        :isJudgeResult="isJudgeResult"
        :key="processId"
        :case-state="caseState"
        :process-id="processId"
        :case-id="caseId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
        judge-type="civil"
      />
      <!-- 执行 -->
      <carry-out
        v-if="tabActive == 'CO_CO'"
        :key="processId"
        :process-id="processId"
        :case-id="caseId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 到款记录 -->
      <paymentConfirmation
        v-if="tabActive == 'ST'"
        :key="processId"
        :casetype="casetype"
        :process-id="processId"
        :case-id="caseId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 归档 -->
      <close-case
        v-if="tabActive == 'EC_EC'"
        :key="processId"
        :case-state="caseState"
        :process-id="processId"
        :case-id="caseId"
        :edit-state="editable"
        @reloadProcess="reloadProcess"
      />
      <!-- 调解 -->
      <mediate
        v-if="tabActive == 'ME_AP'"
        :key="processId"
        :is-button-click="isButtonClick"
        :case-state="caseState"
        :process-id="processId"
        :tab-active="'ME_AP'"
        :case-id="caseId"
        :edit-state="editable"
        :node-id="nodeId"
        :prev-process-id="prevProcessId"
        @reloadProcess="reloadProcess"
      />
      <!-- 和解 -->
      <compromise
        v-if="tabActive == 'RE_AP'"
        :key="processId"
        :is-button-click="isButtonClick"
        :case-state="caseState"
        :process-id="processId"
        :tab-active="'RE_AP'"
        :node-next-id="nodeNextId"
        :prev-code="prevCode"
        :case-id="caseId"
        :node-id="nodeId"
        :prev-process-id="prevProcessId"
        @reloadProcess="reloadProcess"
      />
      <!-- 撤诉 -->
      <withdraw
        v-if="tabActive == 'WD_AP'"
        :key="processId"
        :is-button-click="isButtonClick"
        :case-state="caseState"
        :process-id="processId"
        :tab-active="'WD_AP'"
        :case-id="caseId"
        :edit-state="editable"
        :node-id="nodeId"
        :prev-process-id="prevProcessId"
        @reloadProcess="reloadProcess"
      />
    </div>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import carryOut from '../civilCase/carryOut/index.vue'
import caseTrial from '../civilCase/caseTrial/index.vue'
import sendLetter from '../civilCase/sendLetter/sendLetter.vue'
import lawsuitProgramme from '../civilCase/lawsuitProgramme/index.vue'
import prosecute from '../civilCase/prosecute/index.vue'
import pretrial from '../civilCase/pretrial/index.vue'
import adjudicate from '../civilCase/adjudicate/index.vue'
import paymentConfirmation from '../civilCase/paymentConfirmation/index.vue'
import closeCase from '../civilCase/closeCase/index.vue'
import mediate from '../civilCase/listOptions/mediate.vue'
import compromise from '../civilCase/listOptions/compromise.vue'
import withdraw from '../civilCase/listOptions/withdraw.vue'
export default {
  components: {
    carryOut,
    caseTrial,
    sendLetter,
    lawsuitProgramme,
    prosecute,
    pretrial,
    adjudicate,
    paymentConfirmation,
    closeCase,
    mediate,
    compromise,
    withdraw
  },
  // casetype:案件类型 CL
  props: ['caseId', 'projectId', 'caseState', 'casetype', 'gotoNode'],
  data() {
    return {
      isButtonClick: false, // 控制调解、和解、判决是否是点击节点旁按钮的，因为是的话默认是新增，不是的话才会根据情况判断
      styles: styles,
      tabActive: '',
      processId: '',
      nodeId: '',
      processState: '',
      editable: true,
      isJudgeResult: false,
      processList: [],
      caseTrialState: false,
      prevCode: '',
      loading: false,
      lockKey: 0,
      nodeList: [],
      nodeReduceData: [],
      nodeReduceId: '',
      nodeFormCtrl: true,
      nodeNewArr: [],
      nodeNextId: '',
      prevCodeProcessId: '',
      prevProcessId: '',
      codeButton: [
        { name: '和解', value: 'RE_AP' },
        { name: '调解', value: 'ME_AP' },
        { name: '撤诉', value: 'WD_AP' }
      ]
    }
  },
  computed: {
    buttonIndex() {
      const index = 0
      const arr = [...this.processList]
      arr.reverse()
      const findIndex = arr.findIndex(item => item.colorMark)
      if (findIndex !== -1) {
        return this.processList.length - 1 - findIndex
      } else {
        return index
      }
    }
  },
  watch: {},
  created() {
    this.$store.dispatch('qcc/getQccData', this.caseId)
  },
  beforeMount() { },
  async mounted() {
    await this.getCaseProcess()
    if (this.$attrs['default-type']) {
      this.lockKey = 0
      this.isButtnShow(true)
    } else {
      this.isButtnShow()
    }
  },
  updated() { },
  methods: {
    clickCodeButton(data) {
      this.tabActive = data
      if (data === 'RE_AP') {
        this.nodeId = 23
      } else if (data === 'ME_AP') {
        this.nodeId = 25
      } else {
        this.nodeId = 27
      }
      this.isButtonClick = true
    },
    isButtnShow(status) {
      if (!status) {
        this.processList.forEach((r, k) => {
          if (r.logList && r.logList.length > 0) {
            this.lockKey = k
          }
        })
      }
      let tempIndex = -1
      if (this.gotoNode) {
        // 父组件如果存在跳转节点需求，则根据code与传过来的值进行比对选中对应的节点
        tempIndex = this.processList.findIndex(item => item.code === this.gotoNode)
      } else {
        // 结算节点是否存在认领/录入操作(state === 3)，有则定位到该节点
        tempIndex = this.processList.findIndex(item => item.state === 3)
      }
      if (tempIndex !== -1) {
        this.lockKey = tempIndex
      }
      if (this.lockKey == 0) {
        this.lockKey = 1
      }
      const item = this.processList[this.lockKey]
      item && this.chooseNode(item.code, item.processId, item.state, item.editable, item)
    },
    // 流程节点点击事件
    chooseNode(code, id, state, editable, item) {
      this.isButtonClick = false
      this.prevCode = item.prevCode
      this.isJudgeResult = item.flag
      this.tabActive = code
      this.processId = id
      this.processState = state
      this.editable = editable
      this.nodeNextId = item.id
      this.prevProcessId = item.prevCodeProcessId
    },

    // 节点options操作
    chooseOptionalNode(code, id, nodeId, optional) {
      this.tabActive = code
      this.processId = id
      this.nodeId = nodeId
      this.nodeReduceId = ''
      this.prevProcessId = ''
    },
    // 获取案件进程节点
    getCaseProcess() {
      const url = '/business/case/process?caseId=' + this.caseId
      return this.$get(url).then(async res => {
        if (res.code === 0) {
          const list = res.data
          let index = 0
          if (res.data.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i != 0) {
                list[i].prevCode = list[i - 1].code
                list[i].prevCodeProcessId = list[i - 1].processId
              }
              if (list[i].state == 0) {
                index = i
                break
              } else {
                index = list.length
              }
              // 是否显示起诉节点的调解按钮
              if (list[i].code === 'RR' && list[i].state == 1) {
                const mediateBeforeSueState = await this.getDetail(list[i].processId, 'mediateBeforeSueState')

                if (!mediateBeforeSueState) {
                  list[i].optionalNode && list[i].optionalNode.map(item => {
                    if (item.code === 'ME_AP') { // 隐藏调解节点
                      item.flag = true
                    }
                    return item
                  })
                }
              }
              // 是否出现判决结果选项

              if (list[i].code === 'JT_BB' && (list[i].state == 1 /* || list[i].state == 2 */)) {
                const adjudicateState = await this.getDetail(list[i].processId, 'adjudicateState')
                console.log('adjudicateState：', adjudicateState)

                if (adjudicateState) {
                  list[i].flag = true
                  list[i].optionalNode && list[i].optionalNode.map(item => {
                    if (item.code === 'ME_AP') { // 隐藏调解节点
                      item.flag = true
                    }
                    return item
                  })
                }
              }
              // 庭审的state是否为2(完成)
              if (list[i].code === 'CG_CG' && list[i].state === 2) {
                this.caseTrialState = true
              }
            }
            this.processList = list
            this.tabActive = this.processList[index - 1].code
            this.processId = this.processList[index - 1].processId
            console.log('index：', index, 'this.processList[index - 1]：', this.processList[index - 1], 'processId：', this.processId)
            this.processState = this.processList[index - 1].state
            this.editable = this.processList[index - 1].editable
            this.prevCode = this.processList[index - 2] ? this.processList[index - 2].code : ''
            this.prevCodeProcessId = this.processList[index - 2] ? this.processList[index - 2].processId : ''
          }
        }
      })
    },
    // 获取起诉和判决详情
    getDetail(id, nodeType) {
      const _this = this
      let url
      if (nodeType === 'mediateBeforeSueState') {
        url = '/business/case/mediation?type=BL&processId=' + id
      } else if (nodeType === 'adjudicateState') {
        url = '/business/case/judgment?processId=' + id
      }
      return new Promise(function (resolve, reject) {
        _this.$get(url).then(res => {
          if (res.code == 0 && res.data) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    async reloadProcess() {
      this.tabActive = ''

      await this.getCaseProcess()
      this.isButtnShow()
    }
  }
}
</script>
<style scoped lang="scss">
@import '../case/caseProgress.scss';
</style>



// WEBPACK FOOTER //
// src/view/civilCase/index.vue